const PastSessions = () => {
  const pastVideos = [
    { url: "https://www.youtube.com/embed/DcCseK0t3ps", title: "Prophecy about the New Pope given on Sunday 4th May 2025" },
    { url: "https://www.youtube.com/embed/nNkhHQWA1m8", title: "THE GOD WHO IS FULL OF GOODNESS By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/7couxWInKvQ", title: "THE WAY OF PEACE By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/QGj34OkIMTg", title: "THE GOD WHO GIVES FAVOR By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/QvkiVfWeB5c", title: "THE GOD WHO LIFTS MEN By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/HHDHvLPOyFI", title: "THE GOD WHO DOES NOT FAIL By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/1Us9kScAMcU", title: "ALL THINGS ARE POSSIBLE By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/kqQFfpmRaI8", title: "WITCHCRAFT, WITCHES AND BEWITCHMENT By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/5soQCpI_Rlo", title: "ALL THINGS ARE NEW By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/Brb6VSxPhmw", title: "ALL THINGS ARE YOURS By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/lMVep8dOq10", title: "JEHOVAH THE LOCATOR" },
    { url: "https://www.youtube.com/embed/Gy0oA2QoJ2c", title: "THE GOD WHO CAN NOT LIE By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/zCaulIWXLeU", title: "JEHOVAH THE LOCATOR" },
    { url: "https://www.youtube.com/embed/jVnHA22XUcI", title: "ALL THINGS ARE NOW READY By Prophet Kevin N." },
    { url: "https://www.youtube.com/embed/iFZMKG1eFvk", title: "JEHOVAH THE LOCATOR" },
  ];

  return (
    <div className="mt-5 text-secondary">
      <h2 className="text-2xl border-b-4 border-border font-semibold mb-4 text-center">
        Previous Live Sessions
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {pastVideos.map((video, index) => (
          <div
            key={index}
            className="flex flex-col items-center rounded overflow-hidden border border-border hover:scale-105 transform transition duration-300"
          >
            <div className="w-full aspect-video">
              <iframe
                src={video.url}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
            <div className="w-full h-full bg-black text-white text-sm font-semibold text-center p-2">
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PastSessions;
